import { queryDecoder, queryEncoder } from '~/utils/query-codec.js';

import routesMatcher from '../router/routes-matcher.js';

const createContexts = configuration =>
	configuration.map(([key, paths]) => ({
		key,
		paths,
		routesMatcher: routesMatcher(paths),
		queryEncoder: queryEncoder(key),
		queryDecoder: queryDecoder(key)
	}));

export default createContexts;
